export function modelParts(value) {
  return String(value || '').split('/').map(v => v.trim().replace(/^iphone\s*/i, '')).filter(Boolean).map(v => 'iPhone ' + v);
}
const normalize = v => String(v || '').trim().replace(/\s+/g, ' ').toLowerCase();
export function modelMatches(value, model) {
  return modelParts(value).some(v => normalize(v) === normalize(model));
}
export function matchingVariant(product, model) {
  const index = product.options.findIndex(name => normalize(name) === 'modelo');
  if (index < 0) return null;
  return product.variants.find(v => v.available && modelMatches(v.options[index], model)) || null;
}
export function connectorFor(model) {
  const m = normalize(model);
  if (m === 'iphone air') return 'usb-c';
  if (/^iphone (x|xr|xs|xs max|se \((2020|2022)\))$/.test(m)) return 'lightning';
  const match = m.match(/^iphone (\d+)(e)?(?: (mini|plus|pro|pro max))?$/);
  if (!match) return null;
  const n = Number(match[1]);
  if (n >= 7 && n <= 14) return 'lightning';
  if (n >= 15 && n <= 17) return 'usb-c';
  return null;
}
function money(cents) {
  return new Intl.NumberFormat('es-MX', {style:'currency', currency:'MXN',maximumFractionDigits:0}).format(cents / 100);
}
function node(tag, className, text) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (text != null) el.textContent = text;
  return el;
}
function initFinder(root) {
  if (root.dataset.ready) return;
  const data = JSON.parse(root.querySelector('[data-bc-products]').textContent);
  const select = root.querySelector('select');
  const list = root.querySelector('[data-bc-results]');
  const status = root.querySelector('[data-bc-status]');
  const section = root.closest('.shopify-section');
  const models = new Set();
  data.forEach(p => {
    const i = p.options.findIndex(n => normalize(n) === 'modelo');
    if (i >= 0) p.variants.forEach(v => modelParts(v.options[i]).forEach(m => models.add(m)));
  });
  [...models].sort((a,b) => a.localeCompare(b,'es',{numeric:true})).forEach(model => {
    const option = node('option','',model); option.value = model; select.append(option);
  });
  function render() {
    const model = select.value;
    list.replaceChildren();
    const filtered = Boolean(model);
    section?.classList.toggle('bc-model-filtered',filtered);
    list.hidden = !filtered;
    root.querySelector('[data-bc-reset]').hidden = !filtered;
    if (!filtered) {status.textContent = '';return;}
    for (const p of data) {
      let variant;
      if (p.kind === 'universal') variant = p.variants.find(v => v.available);
      else if (p.kind === connectorFor(model)) variant = p.variants.find(v => v.available);
      else variant = matchingVariant(p,model);
      if (!variant) continue;
      const card = node('a','bc-finder-card');
      card.href = p.url + '?variant=' + encodeURIComponent(variant.id);
      const img = node('img'); img.src = variant.image || p.image; img.alt = p.title; img.width = 280; img.height = 280; img.loading = 'lazy';
      card.append(img);
      card.append(node('span','bc-finder-kind', p.kind === 'universal' ? 'Universal · a la medida' : model));
      card.append(node('h3','',p.title));
      const bottom = node('div','bc-finder-bottom');
      bottom.append(node('strong','',money(variant.price)),node('span','bc-finder-arrow','→'));
      card.append(bottom);
      card.append(node('span',p.shipping === 'gratis'?'bc-finder-shipping bc-free':'bc-finder-shipping',p.shipping === 'gratis'?'Envío gratis · Ver plazo':'Exprés · 4–6 días'));
      list.append(card);
    }
    status.textContent = list.children.length ? list.children.length + ' opciones disponibles para ' + model : 'Por ahora no hay accesorios disponibles para este modelo.';
  }
  select.addEventListener('change',render);
  root.querySelector('[data-bc-reset]').addEventListener('click',()=>{select.value='';render();select.focus();});
  root.dataset.ready='true';
}
function init(scope=document) {
  scope.querySelectorAll('[data-bc-finder]').forEach(initFinder);
  scope.querySelectorAll('[data-bc-wholesale]').forEach(initWholesale);
}

export function wholesaleSelection(rows) {
  const result={items:[],total:0,count:0,lines:[]};
  for (const row of rows) {
    const raw=String(row.quantity ?? '').trim();
    const q=raw===''?0:Number(raw);
    if (!Number.isSafeInteger(q) || q<0 || q>row.max) throw new Error('Revisa la cantidad de '+row.title+'.');
    if(q===0)continue;
    result.items.push({id:String(row.id),quantity:q});
    result.total+=row.price*q; result.count+=q; result.lines.push(q+' × '+row.title);
  }
  return result;
}
function initWholesale(root) {
  if(root.dataset.ready)return;
  const form=root.querySelector('form');
  const rows=[...root.querySelectorAll('[data-bc-row]')];
  const inputs=rows.map(r=>r.querySelector('input[type=number]'));
  const output=root.querySelector('[data-bc-total]');
  const msg=root.querySelector('[data-bc-message]');
  const submit=root.querySelector('[data-bc-add]');
  const quote=root.querySelector('[data-bc-quote]');
  const search=root.querySelector('input[type=search]');
  const kind=root.querySelector('select');
  let busy=false, uncertain=false;
  function selection() {
    return wholesaleSelection(rows.map((r,i)=>({id:r.dataset.id,title:r.dataset.title,price:Number(r.dataset.price),max:Number(inputs[i].max),quantity:inputs[i].value})));
  }
  function update() {
    try {
      const s=selection();
      output.textContent=s.count+' piezas · '+money(s.total);
      submit.disabled=!s.count || busy || uncertain;
      const text=s.count ? 'Hola Black Cell, quisiera cotizar estas refacciones para mi negocio:\n'+s.lines.join('\n')+'\nPrecio de catálogo: '+money(s.total)+' MXN (IVA incluido). ¿Qué opción de envío y precio por volumen me pueden ofrecer? Mi CP es: ' : 'Hola Black Cell, soy técnico o locatario y quisiera cotizar refacciones por volumen. Mi CP es: ';
      quote.href='https://wa.me/524492542960?text='+encodeURIComponent(text);
      if(!busy&&!uncertain)msg.textContent='';
    } catch(error) {submit.disabled=true;msg.textContent=error.message;}
  }
  function filter() {
    let count=0;
    for(const row of rows) {
      const show=normalize(row.dataset.title).includes(normalize(search.value)) && (!kind.value || row.dataset.kind===kind.value);
      row.hidden=!show;if(show)count++;
    }
    root.querySelector('[data-bc-empty]').hidden=count>0;
  }
  form.addEventListener('input',update);
  search.addEventListener('input',filter);kind.addEventListener('change',filter);
  form.addEventListener('submit',async event=>{
    event.preventDefault(); if(busy||uncertain)return;
    if(!form.reportValidity())return;
    let s;try{s=selection();}catch(error){msg.textContent=error.message;return;}
    if(!s.count)return;
    busy=true;update();msg.textContent='Agregando tus refacciones…';
    try {
      const res=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:s.items})});
      const data=await res.json();
      if(!res.ok){uncertain=true;busy=false;submit.disabled=true;msg.textContent=(typeof data.description==='string'?data.description+' ':'')+'No pudimos confirmar que se agregara todo. Abre tu carrito y revisa las cantidades antes de volver a intentarlo.';return;}
      window.location.assign(root.dataset.cart);
    } catch(error) {
      uncertain=true;busy=false;submit.disabled=true;
      msg.textContent='No pudimos confirmar el resultado. Abre tu carrito antes de volver a intentarlo.';
    }
  });
  root.dataset.ready='true';update();
}

if (typeof document !== 'undefined') {
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
}

